import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueTypesRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-types',
	path: '/plugins/servlet/project-config/:projectKey/issuetypes',
};
